import { PageInfo } from 'src/app/shared/model/PageInfo';
import { Template } from './TemplateModels';

export class TemplatesResponse {
  constructor(public templates: Template[], public pageInfo: PageInfo) {}
}
